export default __webpack_public_path__ + "static/media/ic-close.e1c23a3c.svg";